import axios from "axios";
import { BACKEND_URL } from "../backendURL";


class NotificationService {

    getNotificationsList(token, filters) {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: params
        };

        const api_url = BACKEND_URL + "/api/sns/my-notifications/";

        return axios.get(api_url, config);
    };

}

export default new NotificationService();